module.exports = __webpack_public_path__ + "static/media/onboarding14.c228ae22.svg";